import { styled } from "@mui/system";
import { colors } from "../../config/colors";
import {
  DISPLAY_FLEX,
  FLEX_DIRECTION_COLUMN,
  FLEX_DIRECTION_ROW,
  FLEX_ALIGN_CENTER,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  BORDER_RADIUS_SM,
  BORDER_RADIUS_MD,
  FONT_WEIGHT_MEDIUM,
  FONT_SIZE_LG,
} from "../../config/styles";

export const PricingStyled = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  padding: "0px 40px",
  marginLeft: "256px",
  backgroundColor: theme.palette.secondary.contrastText,
  borderRadius: "12px 0px",
  minHeight: "calc(100vh - 100px)",
}));

export const PricingListStyled = styled("div")(() => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  gap: "16px",
  width: "100%",
  "& .toolbar": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    alignItems: FLEX_ALIGN_CENTER,
    gap: "8px",
  },
  "& .tabs": {
    display: DISPLAY_FLEX,
    alignItems: FLEX_ALIGN_CENTER,
    gap: "8px",
  },
  "& .tab": {
    height: "36px",
    padding: "0px 12px",
    borderRadius: BORDER_RADIUS_SM,
    border: "none",
    background: "transparent",
    color: colors.nonActive,
    cursor: "pointer",
    outline: "none",
    transition: "background 0.2s ease, color 0.2s ease",
  },
  "& .tab-active": {
    background: colors.background,
    color: colors.custom,
    fontWeight: 500,
  },
  "& .pending-dot": {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background: colors.warning,
    display: "inline-block",
    marginRight: "6px",
  },
  "& .submit-btn": {
    height: "36px",
    padding: "0px 12px",
    borderRadius: BORDER_RADIUS_SM,
    border: "none",
    background: colors.warning,
    color: colors.white,
    cursor: "pointer",
    transition: "opacity 0.2s ease",
  },
  "& .submit-btn:disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  
  "& .grid": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    border: `1px solid ${colors.storkeLight}`,
    borderRadius: BORDER_RADIUS_MD,
    overflow: "hidden",
    background: colors.white,
    maxHeight: "calc(100vh - 200px)",
  },
  
  "& .header-row": {
    display: "grid",
    background: colors.background,
    borderBottom: `1px solid ${colors.storkeLight}`,
    minHeight: "42px",
    alignItems: "center",
    position: "sticky",
    top: 0,
    zIndex: 10,
    flexShrink: 0,
  },
  
  "& .grid-body": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    overflowY: "auto", 
    overflowX: "hidden",
    flexGrow: 1,
    WebkitOverflowScrolling: "touch",
  },
  
  "& .head-cell": {
    padding: "11px 16px",
    color: colors.nonActive,
    fontSize: "14px",
    fontWeight: 500,
  },
  "& .body-row": {
    display: "grid",
    borderBottom: `1px solid ${colors.storkeLight}`,
    minHeight: "46px",
    alignItems: "center",
    transition: "background-color 0.15s ease",
    cursor: "pointer",
  },
  "& .body-row:last-of-type": {
    borderBottom: "none",
  },
  "& .body-row:hover": {
    background: "#fdfdfd",
  },
  "& .row-selected": {
    background: "#fafafa",
  },
  "& .cell": {
    padding: "8px 16px",
    color: colors.custom,
    fontSize: "14px",
    display: DISPLAY_FLEX,
    alignItems: FLEX_ALIGN_CENTER,
    minHeight: "46px",
  },
  "& .tree-cell": {
    gap: "8px",
  },
  "& .toggle-btn": {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: 0,
    display: "flex",
    alignItems: "center",
    height: "18px",
    outline: "none",
  },
  "& .rate-cell": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: "flex-start",
    justifyContent: "center",
    gap: "2px",
  },
  "& .rate-input": {
    width: "100%",
    maxWidth: "120px",
    height: "32px",
    borderRadius: BORDER_RADIUS_SM,
    border: `1px solid ${colors.grayBackground}`,
    padding: "6px 10px",
    outline: "none",
    transition: "border-color 0.2s ease",
  },
  "& .rate-input:focus": {
    borderColor: colors.custom,
  },
  "& .rate-input:disabled": {
    background: colors.background,
    color: colors.nonActive,
    cursor: "not-allowed",
    opacity: 0.7,
  },
  "& .rate-input-error": {
    borderColor: colors.error,
  },
  "& .input-error": {
    color: colors.error,
    fontSize: "12px",
    lineHeight: "14px",
  },
  "& .muted-rate": {
    color: colors.nonActive,
  },
  "& .tab-placeholder": {
    padding: "20px 0",
    color: colors.nonActive,
  },
  "& .empty": {
    padding: "20px",
    color: colors.nonActive,
  },
  "& .center-empty-msg": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "350px",
    width: "100%",
    fontSize: FONT_SIZE_LG,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_MEDIUM,
    color: colors.custom,
  },
}));